import { useState } from 'react';
import FloppyIcon from 'components/icons/floppy';
import { Llmtestinput } from 'data/firestore/agent/llmtestinput/types';
import Shine from 'components/icons/shine';
import LLMTestInputPickerButton from './LLMTestInputPickerButton';
import { ActionsContainer, ActionButton } from './styled';
import isValidJson from './helpers/isValidJson';

const LLMTestJsonInputActions = ({
    agentId,
    featureSchema,
    currentInputValue,
    onRequestGenerate = () => {},
    onSave = () => {},
    onSelect = () => {},
    onDelete = () => {},
}: {
    agentId: string;
    featureSchema?: string;
    currentInputValue?: string;
    onRequestGenerate?: () => void;
    onSave?: (data: Partial<Llmtestinput>) => void;
    onSelect?: (content: string) => void;
    onDelete?: (inputId: string) => void;
}) => {
    const [currentSelected, setSelected] = useState<Llmtestinput>();

    const handleSelect = (input: Llmtestinput) => {
        setSelected(input);
        onSelect(input.content);
    };

    const handleSave = async () => {
        const result = await onSave({
            ...(currentSelected || {}),
            content: currentInputValue,
        }) as unknown as Llmtestinput;
        if (result?.id) {
            setSelected(result);
        }
    };

    const handleRemove = async (inputId: string) => {
        const result = await onDelete(inputId) as unknown as string;
        if (result && result === currentSelected?.id) {
            setSelected(undefined);
        }
    };

    return (
        <ActionsContainer>
            <LLMTestInputPickerButton
                agentId={agentId}
                featureSchema={featureSchema}
                onSelect={handleSelect}
                onDelete={handleRemove}
            />
            <ActionButton
                icon={<FloppyIcon title=" " />}
                borderRadius="semi-square"
                tooltip="Save"
                disabled={!isValidJson(currentInputValue || '')}
                onClick={handleSave}
            />
            <ActionButton
                icon={<Shine title=" " />}
                borderRadius="semi-square"
                tooltip="Generate input"
                onClick={onRequestGenerate}
            />
        </ActionsContainer>
    );
};

export default LLMTestJsonInputActions;
